/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCaseAlertReason
 */
export interface InternalApiCaseAlertReason {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCaseAlertReason
     */
    reason: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiCaseAlertReason
     */
    details: Array<string>;
}

/**
 * Check if a given object implements the InternalApiCaseAlertReason interface.
 */
export function instanceOfInternalApiCaseAlertReason(value: object): value is InternalApiCaseAlertReason {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function InternalApiCaseAlertReasonFromJSON(json: any): InternalApiCaseAlertReason {
    return InternalApiCaseAlertReasonFromJSONTyped(json, false);
}

export function InternalApiCaseAlertReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseAlertReason {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'details': json['details'],
    };
}

export function InternalApiCaseAlertReasonToJSON(json: any): InternalApiCaseAlertReason {
    return InternalApiCaseAlertReasonToJSONTyped(json, false);
}

export function InternalApiCaseAlertReasonToJSONTyped(value?: InternalApiCaseAlertReason | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'details': value['details'],
    };
}

